export const LoadingStatusEnum = {
	NONE: 0,
	SUCCESS: 1,
	FAILED: 2,
	LOADING: 3,
};

export const LoadingStatusList = Object.values(LoadingStatusEnum);

export const ModalTypeEnum = {
	NONE: 0,
	CREATE: 1,
	MODIFY: 2,
};

export const ModalTypeList = Object.values(ModalTypeEnum);

export const ModalStepEnum = {
	NONE: 0,
	STEP_ONE: 1,
	STEP_TWO: 2,
	STEP_THREE: 3,
};

export const MaintenanceStatusEnums = {
	ONLINE: 'online',
	OFFLINE: 'offline',
};

export const PlatformStatusEnums = {
	ACTIVE: 'active',
	BLOCKED: 'blocked',
};

export const RoleEnums = {
	ADMIN: 'admin',
	COMPANY: 'company',
	MANAGER: 'manager',
	STAFF: 'cs',
};

export const SocketTypeEnums = {
	// Conversation
	CONVERSATIONS_PENDING_COMMAND_GET: 'conversations.pending.command.get',
	CONVERSATIONS_PENDING_ACK_GOT: 'conversations.pending.ack.got',
	CONVERSATIONS_ACTIVE_COMMAND_GET: 'conversations.active.command.get',
	CONVERSATIONS_ACTIVE_ACK_GOT: 'conversations.active.ack.got',
	CONVERSATIONS_CLOSED_COMMAND_GET: 'conversations.closed.command.get',
	CONVERSATIONS_CLOSED_ACK_GOT: 'conversations.closed.ack.got',
	CONVERSATION_COUNT_COMMAND_GET: 'conversations.count.command.get',
	CONVERSATION_COUNT_ACK_GOT: 'conversations.count.ack.got',
	CONVERSATIONS_UNREAD_COMMAND_GET: 'conversations.unread.command.get',
	CONVERSATIONS_UNREAD_ACK_GOT: 'conversations.unread.ack.got',
	CONVERSATIONS_REPLY_MONITOR_INTERCEPTED_COMMAND_GET: 'conversations.reply-monitor-intercepted.command.get',
	CONVERSATIONS_REPLY_MONITOR_INTERCEPTED_ACK_GOT: 'conversations.reply-monitor-intercepted.ack.got',
	CONVERSATIONS_KEYWORD_ALERT_COMMAND_GET: 'conversations.keyword-alert.command.get',
	CONVERSATIONS_KEYWORD_ALERT_ACK_GOT: 'conversations.keyword-alert.ack.got',
	CONVERSATIONS_KEYWORD_ALERT_COMMAND_GET_ERROR: 'conversations.keyword-alert.command.get.error',
	CONVERSATION_COMMAND_SELECT: 'conversation.command.select',
	CONVERSATION_ACK_SELECTED: 'conversation.ack.selected',
	CONVERSATION_COMMAND_SELECT_ERROR: 'conversation.command.select.error',
	CONVERSATION_TAGS_COMMAND_UPDATE: 'conversation.tags.command.update',
	CONVERSATION_TAGS_ACK_UPDATED: 'conversation.tags.ack.updated',
	CONVERSATION_TAGS_EVENT_UPDATED: 'conversation.tags.event.updated',
	CONVERSATION_COMMAND_GET: 'conversation.command.get',
	CONVERSATION_ACK_GOT: 'conversation.ack.got',
	CONVERSATION_COMMAND_GET_ERROR: 'conversation.command.get.error',
	CONVERSATION_COMMAND_ACTIVE: 'conversation.command.active',
	CONVERSATION_ACK_ACTIVE: 'conversation.ack.actived',
	CONVERSATION_COMMAND_ACTIVE_ERROR: 'conversation.command.active.error',
	CONVERSATION_COMMAND_CLOSE: 'conversation.command.close',
	CONVERSATION_ACK_CLOSED: 'conversation.ack.closed',
	CONVERSATION_COMMAND_CLOSE_ERROR: 'conversation.command.close.error',
	CONVERSATION_COWORKERS_COMMAND_DELETE: 'conversation.coworkers.command.delete',
	CONVERSATION_COWORKERS_ACK_DELETED: 'conversation.coworkers.ack.deleted',
	CONVERSATION_COWORKERS_COMMAND_DELETE_ERROR: 'conversation.coworkers.command.delete.error',
	CONVERSATION_COMMAND_LEAVE: 'conversation.command.leave',
	CONVERSATION_ACK_LEFT: 'conversation.ack.left',
	CONVERSATION_COMMAND_LEAVE_ERROR: 'conversation.command.leave.error',
	CONVERSATION_STATUS_EVENT_UPDATED: 'conversation.status.event.updated',
	CONVERSATION_TEXT_SIZE_COMMAND_UPDATE: 'conversation.text-size.command.update',
	CONVERSATION_TEXT_SIZE_ACK_UPDATED: 'conversation.text-size.ack.updated',
	CONVERSATION_TEXT_SIZE_COMMAND_UPDATE_ERROR: 'conversation.text-size.command.update.error',
	CONVERSATION_NORMAL_REPLY_COMMAND_CREATE: 'conversation.normal-reply.command.create',
	CONVERSATION_NORMAL_REPLY_ACK_CREATED: 'conversation.normal-reply.ack.created',
	CONVERSATION_NORMAL_REPLY_COMMAND_CREATE_ERROR: 'conversation.normal-reply.command.create.error',
	CONVERSATION_QUICK_PATH_COMMAND_CREATE: 'conversation.quick-path.command.create',
	CONVERSATION_QUICK_PATH_ACK_CREATED: 'conversation.quick-path.ack.created',
	CONVERSATION_QUICK_PATH_COMMAND_CREATE_ERROR: 'conversation.quick-path.command.create.error',
	CONVERSATION_SMART_REPLY_COMMAND_CREATE: 'conversation.smart-reply.command.create',
	CONVERSATION_SMART_REPLY_ACK_CREATED: 'conversation.smart-reply.ack.created',
	CONVERSATION_SMART_REPLY_COMMAND_CREATE_ERROR: 'conversation.smart-reply.command.create.error',
	CONVERSATION_SCORE_COMMAND_UPDATE: 'conversation.score.command.update',
	CONVERSATION_SCORE_ACK_UPDATED: 'conversation.score.ack.updated',
	CONVERSATION_SCORE_COMMAND_UPDATE_ERROR: 'conversation.score.command.update.error',
	CONVERSATION_USER_EVENT_UPDATED: 'conversation.user.event.updated',
	CONVERSATION_COWORKERS_EVENT_UPDATED: 'conversation.coworkers.event.updated',
	CONVERSATION_COLOR_MAPPING_EVENT_UPDATED: 'conversation.color-mapping.event.updated',
	CONVERSATION_CLIENT_STATUS_EVENT_UPDATED: 'conversation.client-status.event.updated',
	CONVERSATION_NEW_CLIENT_REPLY_COUNT_EVENT_UPDATED: 'conversation.new-client-reply-count.event.updated',
	CONVERSATION_TEXT_SIZE_EVENT_UPDATED: 'conversation.text-size.event.updated',
	CONVERSATION_EVENT_CREATED: 'conversation.event.created',
	CONVERSATION_SESSION_COMMAND_CLEAR: 'conversation.session.command.clear',
	CONVERSATION_SESSION_ACK_CLEARED: 'conversation.session.ack.cleared',
	CONVERSATION_SESSION_COMMAND_CLEAR_ERROR: 'conversation.session.command.clear.error',
	CONVERSATION_SESSION_EVENT_CLEARED: 'conversation.session.event.cleared',
	CONVERSATION_USER_PROFILE_EVENT_UPDATED: 'conversation.user-profile.event.updated',
	CONVERSATION_COMMAND_FOLLOW: 'conversation.command.follow',
	CONVERSATION_ACK_FOLLOWED: 'conversation.ack.followed',
	CONVERSATION_COMMAND_FOLLOW_ERROR: 'conversation.command.follow.error',
	CONVERSATION_COMMAND_UNFOLLOW: 'conversation.command.unfollow',
	CONVERSATION_ACK_UNFOLLOWED: 'conversation.ack.unfollowed',
	CONVERSATION_IS_FOLLOWING_EVENT_UPDATED: 'conversation.is-following.event.updated',
	CONVERSATION_ASSISTANT_COMMAND_CLOSE: 'conversation.assistant.command.close',
	CONVERSATION_ASSISTANT_ACK_CLOSED: 'conversation.assistant.ack.closed',
	CONVERSATION_ASSISTANT_COMMAND_ACTIVE: 'conversation.assistant.command.active',
	CONVERSATION_ASSISTANT_ACK_ACTIVE: 'conversation.assistant.ack.active',
	CONVERSATION_ASSISTANT_STATUS_EVENT_UPDATED: 'conversation.assistant-status.event.updated',
	CONVERSATIONS_CLIENT_HISTORIES_COMMAND_GET: 'conversations.client-histories.command.get',
	CONVERSATIONS_CLIENT_HISTORIES_COMMAND_GET_ERROR: 'conversations.client-histories.command.get.error',
	CONVERSATIONS_CLIENT_HISTORIES_ACK_GOT: 'conversations.client-histories.ack.got',
	CONVERSATION_VIP_CLIENT_COMMAND_UPDATE: 'conversation.vip-client.command.update',
	CONVERSATION_VIP_CLIENT_COMMAND_UPDATE_ERROR: 'conversation.vip-client.command.update.error',
	CONVERSATION_VIP_CLIENT_ACK_UPDATED: 'conversation.vip-client.ack.updated',
	CONVERSATION_VIP_CLIENT_EVENT_UPDATED: 'conversation.vip-client.event.updated',
	CONVERSATION_CLIENT_HISTORIES_COMMAND_CREATE: 'conversation.client-histories.command.create',
	CONVERSATION_CLIENT_HISTORIES_COMMAND_CREATE_ERROR: 'conversation.client-histories.command.create.error',
	CONVERSATION_CLIENT_HISTORIES_ACK_CREATED: 'conversation.client-histories.ack.created',
	CONVERSATION_CLIENT_HISTORY_COUNT_EVENT_UPDATED: 'conversation.client-history-count.event.updated',
	CONVERSATION_CLIENT_HISTORY_EVENT_UPDATED: 'conversations.client-history.event.updated',
	CONVERSATION_REPLY_MONITOR_INTERCEPTED_EVENT_UPDATED: 'conversations.reply-monitor-intercepted.event.updated',
	CONVERSATION_PROMPT_STATUS_COMMAND_UPDATE: 'conversation.prompt-status.command.update',
	CONVERSATION_PROMPT_STATUS_ACK_UPDATED: 'conversation.prompt-status.ack.updated',
	CONVERSATION_PROMPT_STATUS_EVENT_UPDATED: 'conversation.prompt-status.event.updated',

	// Conversation Reply
	CONVERSATION_REPLIES_COMMAND_GET: 'conversation-replies.command.get',
	CONVERSATION_REPLIES_ACK_GOT: 'conversation-replies.ack.got',
	CONVERSATION_REPLIES_COMMAND_GET_ERROR: 'conversation-replies.command.get.error',
	CONVERSATION_REPLY_TEXT_COMMAND_CREATE: 'conversation-reply.text.command.create',
	CONVERSATION_REPLY_TEXT_ACK_CREATED: 'conversation-reply.text.ack.created',
	CONVERSATION_REPLY_TEXT_COMMAND_CREATE_ERROR: 'conversation-reply.text.command.create.error',
	CONVERSATION_REPLY_QUICK_REPLY_COMMAND_CREATE: 'conversation-reply.quick-reply.command.create',
	CONVERSATION_REPLY_QUICK_REPLY_ACK_CREATED: 'conversation-reply.quick-reply.ack.created',
	CONVERSATION_REPLY_QA_OPTIONS_COMMAND_SELECT: 'conversation-reply.qa-options.command.select',
	CONVERSATION_REPLY_QA_OPTIONS_ACK_SELECTED: 'conversation-reply.qa-options.ack.selected',
	CONVERSATION_REPLY_QA_OPTIONS_COMMAND_SELECT_ERROR: 'conversation-reply.qa-options.command.select.error',
	CONVERSATION_REPLY_CONTACT_CS_COMMAND_CREATE: 'conversation-reply.contact-cs.command.create',
	CONVERSATION_REPLY_CONTACT_CS_ACK_CREATED: 'conversation-reply.contact-cs.ack.created',
	CONVERSATION_REPLY_CONTACT_CS_COMMAND_CREATE_ERROR: 'conversation-reply.contact-cs.command.create.error',
	CONVERSATION_REPLY_SMART_REPLY_COMMAND_RESET: 'conversation-reply.smart-reply.command.reset',
	CONVERSATION_REPLY_SMART_REPLY_ACK_RESET: 'conversation-reply.smart-reply.ack.reset',
	CONVERSATION_REPLY_QA_FORM_REPLY_COMMAND_CREATE: 'conversation-reply.qa-form-reply.command.create',
	CONVERSATION_REPLY_QA_FORM_REPLY_ACK_CREATED: 'conversation-reply.qa-form-reply.ack.created',
	CONVERSATION_REPLY_QA_FORM_REPLY_COMMAND_CREATE_ERROR: 'conversation-reply.qa-form-reply.command.create.error',
	CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_COMMAND_CREATE: 'conversation-reply.qa-charge-form-form-reply.command.create',
	CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_ACK_CREATED: 'conversation-reply.qa-charge-form-form-reply.ack.created',
	CONVERSATION_REPLY_QA_CHARGE_FORM_REPLY_COMMAND_CREATE_ERROR: 'conversation-reply.qa-charge-form-form-reply.command.create.error',
	CONVERSATION_REPLIES_COMMAND_READ: 'conversation-replies.command.read',
	CONVERSATION_REPLIES_ACK_READ: 'conversation-replies.ack.read',
	CONVERSATION_REPLY_EVENT_CREATED: 'conversation-reply.event.created',
	CONVERSATION_REPLY_FORM_TAGS_COMMAND_CREATE: 'conversation-reply.form-tags.command.create',
	CONVERSATION_REPLY_FORM_TAGS_ACK_CREATED: 'conversation-reply.form-tags.ack.created',
	CONVERSATION_REPLY_FORM_TAGS_COMMAND_CREATE_ERROR: 'conversation-reply.form-tags.command.create.error',
	CONVERSATION_REPLY_FORM_REPLY_COMMAND_CREATE: 'conversation-reply.form-reply.command.create',
	CONVERSATION_REPLY_FORM_REPLY_ACK_CREATED: 'conversation-reply.form-reply.ack.created',
	CONVERSATION_REPLY_FORM_REPLY_COMMAND_CREATE_ERROR: 'conversation-reply.form-reply.command.create.error',
	CONVERSATION_REPLY_TEXT_COMMAND_TYPING: 'conversation-reply.text.command.typing',
	CONVERSATION_REPLY_TEXT_ACK_TYPED: 'conversation-reply.text.ack.typed',
	CONVERSATION_REPLY_TEXT_EVENT_TYPED: 'conversation-reply.text.event.typed',
	CONVERSATION_REPLY_COMMAND_REVOKE: 'conversation-reply.command.revoke',
	CONVERSATION_REPLY_ACK_REVOKED: 'conversation-reply.ack.revoked',
	CONVERSATION_REPLY_COMMAND_RESEND: 'conversation-reply.command.resend',
	CONVERSATION_REPLY_ACK_RESENT: 'conversation-reply.ack.resent',
	CONVERSATION_REPLY_COMMAND_RESEND_ERROR: 'conversation-reply.command.resend.error',
	CONVERSATION_REPLY_EVENT_UPDATED: 'conversation-reply.event.updated',
	CONVERSATION_REPLY_FILE_SHARE_COMMAND_CREATE: 'conversation-reply.file-share.command.create',
	CONVERSATION_REPLY_FILE_SHARE_ACK_CREATED: 'conversation-reply.file-share.ack.created',
	CONVERSATION_REPLY_FILE_SHARE_COMMAND_CREATE_ERROR: 'conversation-reply.file-share.command.create.error',
	CONVERSATION_REPLY_PROMPT_COMMAND_CREATE: 'conversation-reply.prompt.command.create',
	CONVERSATION_REPLY_PROMPT_COMMAND_CREATE_ERROR: 'conversation-reply.prompt.command.create.error',
	CONVERSATION_REPLY_PROMPT_ACK_CREATED: 'conversation-reply.prompt.ack.created',
	CONVERSATION_REPLY_REPLY_MONITOR_COMMAND_RELEASE: 'conversation-reply.reply-monitor.command.release',
	CONVERSATION_REPLY_REPLY_MONITOR_ACK_RELEASED: 'conversation-reply.reply-monitor.ack.released',
	CONVERSATION_REPLY_REPLY_MONITOR_COMMAND_RELEASE_ERROR: 'conversation-reply.reply-monitor.command.release.error',
	// Platform
	PLATFORMS_STATISTICS_COMMAND_GET: 'platforms.statistics.command.get',
	PLATFORMS_STATISTICS_ACK_GOT: 'platforms.statistics.ack.got',
	PLATFORMS_COMMAND_SUBSCRIBE: 'platforms.command.subscribe',
	PLATFORMS_ACK_SUBSCRIBED: 'platforms.ack.subscribed',
	PLATFORMS_COMMAND_SUBSCRIBE_ERROR: 'platforms.command.subscribe.error',
	PLATFORMS_CONVERSATION_COUNT_EVENT_UPDATED: 'platform.conversation-count.event.updated',
	PLATFORMS_NEW_CLIENT_REPLY_COUNT_EVENT_UPDATED: 'platform.new-client-reply-count.event.updated',
	PLATFORM_FOLLOWING_CONVERSATION_COUNT_EVENT_UPDATED: 'platform.following-conversation-count.event.updated',
	PLATFORM_PROMPT_TYPES_COMMAND_GET: 'platform.prompt-types.command.get',
	PLATFORM_PROMPT_TYPES_COMMAND_GET_ERROR: 'platform.prompt-types.command.get.error',
	PLATFORM_PROMPT_TYPES_ACK_GOT: 'platform.prompt-types.ack.got',
	// Invitation
	INVITATIONS_COMMAND_GET: 'invitations.command.get',
	INVITATIONS_ACK_GOT: 'invitations.ack.got',
	INVITATIONS_COMMAND_GET_ERROR: 'invitations.command.get.error',
	CONVERSATION_INVITATIONS_COMMAND_GET: 'conversation.invitations.command.get',
	CONVERSATION_INVITATIONS_ACK_GOT: 'conversation.invitations.ack.got',
	CONVERSATION_INVITATIONS_COMMAND_GET_ERROR: 'conversation.invitations.command.get.error',
	INVITATION_HAND_OVER_COMMAND_CREATE: 'invitation.hand-over.command.create',
	INVITATION_HAND_OVER_ACK_CREATED: 'invitation.hand-over.ack.created',
	INVITATION_HAND_OVER_COMMAND_CREATE_ERROR: 'invitation.hand-over.command.create.error',
	INVITATION_CO_WORK_COMMAND_CREATE: 'invitation.cowork.command.create',
	INVITATION_CO_WORK_ACK_CREATE: 'invitation.cowork.ack.created',
	INVITATION_CO_WORK_COMMAND_CREATE_ERROR: 'invitation.cowork.command.create.error',
	INVITATION_COMMAND_CANCEL: 'invitation.command.cancel',
	INVITATION_ACK_CANCELED: 'invitation.ack.canceled',
	INVITATION_COMMAND_CANCEL_ERROR: 'invitation.command.cancel.error',
	INVITATION_COMMAND_ACCEPT: 'invitation.command.accept',
	INVITATION_ACK_ACCEPT: 'invitation.ack.accepted',
	INVITATION_COMMAND_ACCEPT_ERROR: 'invitation.command.accept.error',
	INVITATION_COMMAND_REJECT: 'invitation.command.reject',
	INVITATION_ACK_REJECTED: 'invitation.ack.rejected',
	INVITATION_COMMAND_REJECT_ERROR: 'invitation.command.reject.error',
	INVITATION_EVENT_CREATED: 'invitation.event.created',
	INVITATION_STATUS_EVENT_UPDATED: 'invitation.status.event.updated',
	// User
	USERS_ONLINE_COMMAND_GET: 'users.online.command.get',
	USERS_ONLINE_ACK_GOT: 'users.online.ack.got',
	USERS_ONLINE_COMMAND_GET_ERROR: 'users.online.command.get.error',
	USERS_ME_LAUGUAGE_COMMAND_UPDATE: 'users.me.language-code.command.update',
	USERS_ME_LAUGUAGE_ACK_GOT: 'users.me.language-code.ack.updated',
	USERS_ME_LAUGUAGE_COMMAND_UPDATE_ERROR: 'users.me.language-code.command.update.error',
	USERS_ME_DISPLAY_NAMES_COMMAND_UPDATE: 'users.me.display-names.command.update',
	USERS_ME_DISPLAY_NAMES_ACK_GOT: 'users.me.display-names.ack.updated',
	USERS_ME_DISPLAY_NAMES_COMMAND_UPDATE_ERROR: 'users.me.display-names.command.update.error',
	USER_ON_BREAK_EVENT_CREATED: 'user.on-break.event.created',
	// Application
	DISCONNECT: 'disconnect',
	CONNECT: 'connect',
	// Service Setting
	SERVICE_SETTING_EVENT_UPDATED: 'service-setting.event.updated',
	// Platform Setting
	PLATFORM_STATUS_EVENT_UPDATED: 'platform.status.event.updated',
	PLATFORM_SETTING_MAINTENANCE_EVENT_UPDATED: 'platform-setting.maintenance.event.updated',

	PING: 'ping',
	PONG: 'pong',
};

export const ConversationFileTypeEnum = {
	IMAGE: 'image',
	VIDEO: 'video',
	ATTACHMENT: 'attachment',
};

export const ConversationReplyTypeEnum = {
	TEXT: 'text',
	ICON: 'icon',
	GREETING: 'greeting',
	...ConversationFileTypeEnum,
	CLIENT_OFFLINE: 'client-offline',
	CLIENT_ONLINE: 'client-online',
	CLIENT_TIMEOUT: 'client-timeout',
	CLIENT_DISCONNECT: 'client-disconnect',
	CLIENT_CLOSE: 'client-close',
	CLIENT_MULTIPLE_LOGIN: 'client-multiple-login',
	CS_REPLY_TIMEOUT: 'cs-reply-timeout',
	CS_CLOSE: 'cs-close',
	PENDING_MESSAGE: 'pending-message',
	ACTIVE_MESSAGE: 'active-message',
	HAND_OVER: 'hand-over',
	JOIN_COWORK: 'join-cowork',
	LEAVE_COWORK: 'leave-cowork',
	CONTACT_CS_MESSAGE: 'contact-cs-message',
	TAGS: 'tags',
	FORM_TAGS: 'form-tags',
	FORM_MESSAGE: 'form-message',
	FORM_REPLY: 'form-reply',
	QUICK_FORM_REPLY: 'quick-action-form-reply',
	QUICK_PATH: 'upload-image', // 快速通道（後端 reply type 仍為 'upload-image'）
	QA_OPTIONS: 'qa-options',
	QA_FORM: 'qa-form',
	QA_ANSWER: 'qa-answer',
	QA_REPLY: 'qa-reply',
	QA_FORM_REPLY: 'qa-form-reply',
	QA_ENDING_MESSAGE: 'qa-ending-message',
	QA_CHARGE_FORM_MESSAGE: 'qa-charge-form-form-message',
	QA_CHARGE_FORM_REPLY: 'qa-charge-form-form-reply',
	CLIENT_DENT_IP: 'client-deny-ip',
	// AI
	ASSISTANT_GREETING: 'assistant-greeting',
	ASSISTANT_TEXT: 'assistant-text', // AI 文字訊息
	ASSISTANT_IMAGE: 'assistant-image', // [AI]派單系統傳送圖片
	ASSISTANT_VIDEO: 'assistant-video', // [AI]派單系統傳送影片
	ASSISTANT_ATTACHMENT: 'assistant-attachment', // [AI]派單系統傳送檔案（PDF）
	ASSISTANT_WARNING: 'assistant-warning', // [AI]侦测到对话有异常状态 请尽快处理
	ASSISTANT_OVER_LIMIT: 'assistant-over-limit', // [AI]侦测到对话有异常状态 - 对话次数超过限制
	ASSISTANT_ERROR: 'assistant-error', // [AI]侦测到对话有异常状态 - 系统发生错误
	ASSISTANT_CONFIRMED: 'assistant-confirmed', // [AI]对话侦测到对话即将完成 请确认
	ASSISTANT_SWITCH_TO_HUMAN: 'assistant-switch-to-human', // [AI]需要转接人工客服 请尽快处理
	ASSISTANT_ENABLED: 'assistant-enabled', // TODO: 目前尚未實作開啟AI功能 [AI]{操作帐号}已于{时间}开启AI
	ASSISTANT_DISABLED: 'assistant-disabled', // [AI]{操作帐号}已于{时间}关闭AI
	ASSISTANT_TIMEOUT_ERROR: 'assistant-timeout-error', // [AI]侦测到对话有异常状态 - AI API 超過兩分鐘沒回覆
	ASSISTANT_OPENAI_ERROR: 'assistant-openai-error', // [AI]侦测到对话有异常状态 - AI 发生错误
	ASSISTANT_EMPTY_MESSAGE_ERROR: 'assistant-empty-message-error', // [AI]侦测到对话有异常状态 - AI 没有回复
	ASSISTANT_MODEL_FAILOVER: 'assistant-model-failover', // [AI]模型切换：A模型 -> B模型（模型異常自動切換，僅客服端與歷史對話顯示）

	// Keyword word
	KEYWORD_ALERT_BY_CLIENT: 'keyword-alert-by-client', // 客戶觸發關鍵字 [{message}] 請客服人員注意
	KEYWORD_ALERT_BY_AI: 'keyword-alert-by-ai', // AI 觸發關鍵字 [{message}] 請客服人員注意

	// Prompt
	MANUAL_PROMPT: 'manual-prompt',
	AUTO_PROMPT: 'auto-prompt',
	AUTO_PROMPT_ENABLED: 'auto-prompt-enabled', // {操作帐号}已于{时间}开启自动推播
	AUTO_PROMPT_DISABLE: 'auto-prompt-disabled', // {操作帐号}已于{时间}关闭自动推播

	// Front-end customize
	REVOCATION_MESSAGE: 'revocation-message',
	REVOCATION_PROMPT: 'revocation-prompt',
};

export const ConversationReadStatusEnum = Object.freeze({
	READ: 'read',
	UNREAD: 'unread',
});

export const ConversationStatusEnum = {
	INIT: 'init',
	PENDING: 'pending',
	ACTIVE: 'active',
	HAND_OVERING: 'hand-overing',
	CLOSED: 'closed',
	CLIENT_CLOSED: 'client-closed',
};

export const AIStatusEnum = {
	ACTIVE: 'active',
	WARNING: 'warning',
	ERROR: 'error',
	CLOSED: 'closed',
};

export const ConversationCloseCodeEnum = {
	CS_CLOSE: 'cs-close',
	CLIENT_CLOSE: 'client-close',
	TIMEOUT: 'timeout',
	MAINTENANCE: 'maintenance',
	CLIENT_DENY_IP: 'client-deny-ip',
};

export const ReplyMonitorInterceptedFilterEnum = {
	// 否，AI 未攔截
	NOT_INTERCEPTED: 'not-intercepted',
	// 是，且修改 AI 建議回覆
	INTERCEPTED_SUGGESTION_MODIFIED: 'intercepted-suggestion-modified',
	// 是，但未修改 AI 建議回覆
	INTERCEPTED_SUGGESTION_UNMODIFIED: 'intercepted-suggestion-unmodified',
};

export const ConversationReplySourceEnum = {
	// 單純AI回覆
	ASSISTANT_ONLY: 'assistant-only',
	// 單純人工回覆
	CS_ONLY: 'cs-only',
	// 人工+AI混合回覆
	MIXED: 'mixed',
};

export const InvitationTypeEnum = {
	HAND_OVER: 'hand-over',
	CO_WORK: 'cowork',
};

export const InvitationStatusEnum = {
	CREATED: 'created',
	CANCELED: 'canceled',
	ACCEPTED: 'accepted',
	REJECTED: 'rejected',
};

export const NotifyQueueTypeEnum = {
	INFO: 'info',
	TRANSFER_INVITATION: 'transfer-invitation',
};

export const VideoExtensionEnum = {
	MOV: 'mov',
	MP4: 'mp4',
};

export const ImageExtensionEnum = {
	JPG: 'jpg',
	JPEG: 'jpeg',
	GIF: 'gif',
	PNG: 'png',
	HEIF: 'heif',
	RAW: 'raw',
	HEIC: 'heic',
	TIF: 'tif',
	TIFF: 'tiff',
	BMP: 'bmp',
};

export const AttachmentExtensionEnum = {
	PDF: 'pdf',
};

export const ScrollBehaviorEnum = Object.freeze({
	AUTO: 'auto',
	SMOOTH: 'smooth',
	INSTANT: 'instant',
});

export const SelectionTypeEnums = {
	OPTION: 'options',
	FORM: 'form',
	ANSWER: 'answer',
	ACTION: 'action',
	CHARGE_FORM: 'charge-form',
};

export const OptionTypeEnum = {
	END: 'end',
	CONTACT_CS: 'contact_cs',
	RESELECT_BOT: 'reselect_bot',
};

// 對應後端 ENUM_QA_NODE_CONTENT_ACTION,值與 OptionTypeEnum.CONTACT_CS 不同,不可互換
export const QANodeActionEnum = {
	CONTACT_CS: 'contact-cs',
};

export const LanguageCodeEnums = {
	ZH_CN: 'zh-cn',
	VI: 'vi',
	TH: 'th',
	EN: 'en',
	BN: 'bn',
	HI: 'hi',
	JA: 'ja',
	KO: 'ko',
	PT: 'pt',
	RU: 'ru',
	ZH_TW: 'zh-tw',

	AUTO: 'auto',
	CLIENT: 'client',
	CS_EN: 'cs-en',
};

export const LanguageNameEnums = {
	CHINESE: '简体中文',
	VIETNAMESE: 'Tiếng Việt',
	THAI: 'ภาษาไทย',
	ENGLISH: 'English',
	BENGALI: 'বাংলা',
	HINDI: 'हिंदी',
	JAPANESE: '日本語',
	KOREAN: '한국어',
	PORTUGUESE: 'Português',
	RUSSIAN: 'Русский',
	TRADITIONAL_CHINESE: '繁體中文',
	AUTO_LANGUAGE: '侦测语言',
};

export const TranslatableLanguageCodes = [
	LanguageCodeEnums.ZH_TW,
	LanguageCodeEnums.ZH_CN,
	LanguageCodeEnums.EN,
	LanguageCodeEnums.KO,
	LanguageCodeEnums.JA,
	LanguageCodeEnums.PT,
	LanguageCodeEnums.BN,
	LanguageCodeEnums.HI,
	LanguageCodeEnums.VI,
	LanguageCodeEnums.TH,
	LanguageCodeEnums.RU,
];

export const LanguageCodeNameMap = {
	[LanguageCodeEnums.ZH_TW]: '繁体中文',
	[LanguageCodeEnums.ZH_CN]: '简体中文',
	[LanguageCodeEnums.EN]: '英语',
	[LanguageCodeEnums.KO]: '韩语',
	[LanguageCodeEnums.JA]: '日语',
	[LanguageCodeEnums.PT]: '葡萄牙语',
	[LanguageCodeEnums.BN]: '孟加拉语',
	[LanguageCodeEnums.HI]: '印地语',
	[LanguageCodeEnums.VI]: '越南语',
	[LanguageCodeEnums.TH]: '泰语',
	[LanguageCodeEnums.RU]: '俄语',
};

export const InvalidRequestStatusEnums = {
	INVALID_ACCOUNT: 422,
	INVALID_TOTP: 401,
};

export const AjaxErrorCodeEnum = {
	WITHOUT_LOGGED_IN: '888.010.402',
	TOTP_VERIFY_ERROR: '888.010.404',
	TOTP_AUTH_ERROR: '888.010.406',
	CLIENT_IP_RULE_NOT_FOUND: '888.001.412',
	IP_WHITELIST_DUPLICATED: '888.022.409',
	USER_NO_AVAILABLE_USER: '888.012.424',
	USER_HAS_ACTIVE_CONVERSATION: '888.012.425',
};

export const OperationTypeEnums = {
	QA_SETTING: 'qa-setting',
	GENERAL_SETTING: 'general-setting',
	ARTICLES: 'article-management',
	ACCOUNTS: 'account-management',
	PLATFORMS: 'platform-management',
	ROLES: 'role-management',
	GROUPS: 'group-management',
	TAGS: 'tag-management',
	QA_VERSIONS: 'qa-version-management',
	QA_COM_INFOS: 'qa-common-information-management',
	COMMON_QUICK_REPLY_SETTING: 'common-quick-reply-setting',
	DEFAULT_CONVERSATION_SCORE_MANAGEMENT: 'default-conversation-score-management',
	QUOTE_MANAGEMENT: 'quote-management',
	REVOKE_CONVERSATION_REPLY_SETTING: 'revoke-conversation-reply-setting',
	CLIENT_IP_RULE_MANAGEMENT: 'client-ip-rule-management',
	IP_WHITELIST_SETTING: 'ip-whitelist-setting',
	QUICK_ACTIONS_MANAGEMENT: 'quick-actions-management',
	UNREAD_MANAGEMENT: 'unread-dashboard',
	STAT_SETTING: 'stat-setting',
	COMPANY_AI_SETTING: 'company-ai-setting',
	PLATFORM_AI_SETTING: 'platform-ai-setting',
	AUTO_ACTIVE_CONVERSATION: 'auto-active-conversation',
	KEYWORD_ALERT: 'keyword-alert', // TODO 根據後端 fix
	PLATFORM_AI_SKILL_SETTING: 'platform-ai-skill-setting',
};

export const QASavingTypeEnums = {
	MANUAL: 'manual',
	AUTOMATIC: 'automatic',
};

export const ChargeFormAccountTypeEnums = {
	ORIGINAL: 'original-client-id',
	CUSTOM: 'custom',
};

export const ChargeFormChargeTypeEnums = {
	WEB: 'web',
	QRCODE: 'qr-code',
};

export const FormItemOptTypeEnums = {
	TITLE: 'title',
	OPTIONS: 'options',
};

export const WaitingAlertStatusEnum = {
	isApplyOnTab: 'isApplyOnTab',
	isApplyOnPending: 'isApplyOnPending',
	isApplyOnActive: 'isApplyOnActive',
};

export const ClientStatusEnum = {
	ONLINE: 'online',
	OFFLINE: 'offline',
};

export const SatisfactionEnum = {
	FIVE: 5,
	FOUR: 4,
	THREE: 3,
	TWO: 2,
	ONE: 1,
};

export const RxjsHttpStatusCode = {
	REQUEST_NOT_COMPLETED: 0,
};

export const ClientIpRuleTypeEnums = {
	// IP 白名單
	ALLOW: 'allow',
	// IP 黑名單
	DENY: 'deny',
};

export const WhetherEnum = {
	HAVE: true,
	NONE: false,
};

export const QuickActionTypeEnum = {
	TEXT: 'text',
	FORM: 'form',
};

export const QuickActionFromTypeEnum = {
	// 輸入框
	TEXT_INPUT: 'text-input',
	// 單選
	RADIO_INPUT: 'radio-input',
	// 核取方塊
	CHECKBOX_INPUT: 'checkbox-input',
	// 上傳檔案
	FILE_INPUT: 'file-input',
};

export const ArticleTagEnum = {
	HOT: 'hot',
	NEW: 'new',
	NONE: 'none',
	REMOVE: 'remove',
};

export const WorkStatusEnum = {
	WORKING: 'working',
	ON_BREAK: 'on-break',
};

export const KeywordTypeEnum = {
	// 全部
	ALL_SPEAK: 'all',
	// 客户发话
	CLIENT_SPEAK: 'client',
	// AI发话
	AI_SPEAK: 'ai',
};

export const ClientLoginTypeEnum = {
	// 標準模式
	STANDARD: 'standard',
	// ID 模式
	ID: 'id',
	// 即進模式
	ANONYMOUS: 'anonymous',
};

export const CompanySourceEnum = {
	// 一般帳號
	CS: 'cs',
	// 包網帳號
	BW: 'bw',
	// 包網（美國）帳號
	BW_US: 'bw-us',
};

export const getIsBWCompany = source =>
	[CompanySourceEnum.BW, CompanySourceEnum.BW_US].includes(source);

export const getIsBWCompanyTotpBindRequired = ({ source, permission, isTotpEnabled }) =>
	getIsBWCompany(source) && permission === RoleEnums.COMPANY && isTotpEnabled === false;

export const ApiKeyEnum = {
	// 主要
	PRIMARY: 'primary',
	// 備用
	SECONDARY: 'secondary',
};

export const LoginMethodEnum = {
	// 使用者透過帳密登入
	PASSWORD: 'password',
	// 使用者從包網轉址登入
	TOKEN: 'token',
};

export const TransportEnum = {
	HTTP: 'http',
	WEB_SOCKET: 'web-socket',
	TRIGGER: 'trigger',
};

export const getKeyFromValue = (enumObj, value) =>
	Object.keys(enumObj).find(key => enumObj[key] === value);

export const MarqueeTagEnum = {
	HOT: 'hot',
	NEW: 'new',
	NEXT: 'next',
};

export const InfoStatusEnum = {
	WORKING: 'working',
	ON_BREAK: 'on-break',
};

export const PromptStatusEnum = {
	ENABLE_AUTO_MODE: 'enable-auto-mode',
	DISABLE_AUTO_MODE: 'disable-auto-mode',
};

export const TextDialogVariantEnum = {
	SERVICE: 'service',
	USER: 'user',
	AI_BOT: 'ai-bot',
	TYPING: 'typing',
};

// 影片轉檔狀態，對應後端 conversationReply.file.conversionStatus（video 才有）
export const ConversionStatusEnum = {
	PROCESSING: 'processing',
	COMPLETED: 'completed',
	FAILED: 'failed',
};

export const InputTypeEnum = {
	TEXT: 'text',
	PASSWORD: 'password',
};

export const TranslateModelEnum = {
	GPT_4O_MINI: 'gpt-4o-mini',
};

// 對應 translatingStatusMap 的值:NONE = 尚未翻譯(等同無此 key);TRANSLATING = 請求進行中;
// DONE = 已有翻譯結果;FAILED = 已失敗,不再自動重派(僅手動重試)
export const TranslatingStatusEnum = {
	NONE: 0,
	TRANSLATING: 1,
	DONE: 2,
	FAILED: 3,
};

export const HistoryPageModeEnum = {
	EMBEDDED: 'embedded',
};

export const ResizeDirectionEnum = {
	HORIZONTAL: 'horizontal',
	VERTICAL: 'vertical',
};

export const ResizeTargetEnum = {
	PREVIOUS: 'previous',
	NEXT: 'next',
};
